import { render, staticRenderFns } from "./CampaignSetupsMessageBody.vue?vue&type=template&id=75441eae&scoped=true"
import script from "./CampaignSetupsMessageBody.vue?vue&type=script&lang=js"
export * from "./CampaignSetupsMessageBody.vue?vue&type=script&lang=js"
import style0 from "./CampaignSetupsMessageBody.vue?vue&type=style&index=0&id=75441eae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75441eae",
  null
  
)

export default component.exports